import axios from 'axios';

export default {
    postScheduleAppointment(cb, { data, ClientToken }) {
        axios
            .post('/api/appointment', 
                data, {
                headers: {
                        Authorization: `Bearer ${ClientToken}`,
                        Dealer: sessionStorage.getItem('dealer')
                } })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
    getClinicInformation(cb, { ClinicUrl, ClientToken }) {
        axios
            .get('/api/Clinic', {
                params: {
                    ClinicUrl
                },
                headers: {
                    Authorization: `Bearer ${ClientToken}`,
                    Dealer: sessionStorage.getItem('dealer')
                }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
    getAppointmentTimeslots(cb, { StartDate, EndDate, AppointmentType, ClinicId, ClientToken }) {
        axios
            .get('/api/Appointment/timeslots', {
                params: {
                    StartDate,
                    EndDate,
                    AppointmentType,
                    ClinicId
                },
                headers: {
                    Authorization: `Bearer ${ClientToken}`,
                    Dealer: sessionStorage.getItem('dealer')
                }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
    getCompanionTypes(cb, { ClientToken }) {
        axios
            .get('/api/CompanionType', {
                headers: {
                    Authorization: `Bearer ${ClientToken}`,
                    Dealer: sessionStorage.getItem('dealer')
                } })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    }
};
